import React, { useCallback } from 'react';
import "../../styles/collections/edit_collection.css";
import { useEffect, useState } from "react";
import { firebaseFirestore } from "../firebase/firebase_configuration";
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore";

const EditCollection = ({getShow, setShow, collectionId, getUserId}) => {
    const [getCollectionName, setCollectionName] = useState("");
    const [getCollectionDescription, setCollectionDescription] = useState("");
    const [getCollectionPrivacy, setCollectionPrivacy] = useState("public");

    const onChangeCollectionName = (name) => {
        setCollectionName(name.target.value);
    };

    const onChangeCollectionDescription = (description) => {
        setCollectionDescription(description.target.value);
    };

    const onSetCollectionPrivacy = (privacy) => {
        setCollectionPrivacy(privacy.target.value);
    };

    const retrieveCollectionDetails = useCallback(() => {
        try {
            const userRef = doc(firebaseFirestore, 'User Collections', getUserId);
            const scription = onSnapshot(userRef, async (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const collectionsData = docSnapshot.data();
                    Object.keys(collectionsData).forEach((fieldName) => {
                        if (fieldName === collectionId) {
                            const collection = collectionsData[fieldName];
                            setCollectionName(collection.name);
                            setCollectionDescription(collection.description);
                            setCollectionPrivacy(collection.privacy);
                        };
                    });
                };
            }); 

            return () => scription;
        } catch (error) {
            console.log(error.message); 
        };
    }, [getUserId, collectionId]);

    const onEditCollection = async () => {
        if (getCollectionName.length < 5) {
            alert("Collection name should be at least 5 character.");
        } else {
            try {
                const userRef = doc(firebaseFirestore, 'User Collections', getUserId);
                const docSnapshot = await getDoc(userRef);
                if (docSnapshot.exists()) {
                    await updateDoc(userRef, {
                        [`${collectionId}.name`]: getCollectionName,
                        [`${collectionId}.description`]: getCollectionDescription,
                        [`${collectionId}.privacy`]: getCollectionPrivacy,
                    });
                } 
            } catch (error) {
                alert("Failed to update collection details. Please try again.");
                console.log(error.message); 
            }

            setShow(false);
        }
    }

    useEffect(() => {
        retrieveCollectionDetails();
    }, [getUserId, collectionId, retrieveCollectionDetails]);

    return(
        <div className={`view_add_collection ${getShow ? "show" : ""}`}>
            <div className="view_add_collection_overlay" onClick={() => setShow(false)}></div>
            <div className="view_add_collection_content">
                <p className="view_add_collection_content_header">Edit Collection</p>
                <p className="view_add_collection_input_label">Collection Name</p>
                <div className="view_add_collection_input_con">
                    <input className="view_add_collection_input" placeholder="Change this collection's name" type="text" maxLength={50} value={getCollectionName} onChange={onChangeCollectionName} />
                </div>

                <p className="view_add_collection_input_label">Collection Description</p>
                <div className="view_add_collection_input_con">
                    <input className="view_add_collection_input" placeholder="Change this collection's description" type="text" maxLength={200} value={getCollectionDescription} onChange={onChangeCollectionDescription} />
                </div>

                <div class="privacy_radio-group">
                    <label>
                        <input type="radio" name="privacy_option" value="public" checked={getCollectionPrivacy === "public"} onChange={onSetCollectionPrivacy} /> Public
                    </label>
                    <label>
                        <input type="radio" name="privacy_option" value="private" checked={getCollectionPrivacy === "private"} onChange={onSetCollectionPrivacy} /> Private
                    </label>
                </div>

                <div className="view_add_collection_button" onClick={onEditCollection}>
                    Edit Collection
                </div>
            </div>
        </div>
    );
};

export default EditCollection;